import { 
	CLAIM_ORDER, 
	REMOVE_ACTIVE_ORDER, 
	SET_ACTIVE_ORDER, 
	SET_QB_TOKEN,
	SET_CANT_FULFILL,
	SET_IMAGE,
	SET_MANUAL_DELIVERY, 
	SYNC_ORDER_TO_DB, 
	TOGGLE_DELIVERY_PICKEDUP, 
	TOGGLE_FULFILLMENT, 
	UPDATE_ADMIN_CONTROLS,
	UPDATE_EMAIL_CAMPAIGNS,
	UPDATE_ORDER, 
	UPDATE_ORDER_PAYMENT_OBJECT,
	UPDATE_PICKUP_DATE, 
	UPDATE_TRACKING_CODE,
	UPDATE_LEAD_TIME
} from './types';

export const claimOrder = (orderId) => {
	return {
		type: CLAIM_ORDER,
		orderId
	}
}

export const removeActiveOrder = () => {
	return {
		type: REMOVE_ACTIVE_ORDER
	}
}

/**
 * Given an order as an input, sets the active order as the input. Active order appears as a modal.
 * @param {object} order - the order to make active
 */
export const setActiveOrder = (order) => {
	return {
		type: SET_ACTIVE_ORDER,
		order
	}
}

export const setQbToken = (qbToken) =>{
	return {
		type: SET_QB_TOKEN,
		qbToken
	}
}

export const setCantFulfill = (product) => {
	return {
		type: SET_CANT_FULFILL,
		product
	}
}

export const setImage = ( product, image ) => {
	return {
		type: SET_IMAGE,
		product,
		image
	}
}

export const setManualDelivery = (product) => {
	return {
		type: SET_MANUAL_DELIVERY,
		product
	}
}

export const syncToDb = (PARAM = false) => {
	return {
		type: SYNC_ORDER_TO_DB,
		PARAM
	}
}

export const toggleDeliveryPickedup = (product) => {
	return {
		type: TOGGLE_DELIVERY_PICKEDUP,
		product,
		// payload:axios({
		// 	url:`${URL_ENDPOINT}/api/admin/orders/fulfill/${order._id}/${product._id}`,
		// 	method:'get',
		// 	withCredentials: true
		// })
	}
}

export const toggleFulfillment = (product) => {
	return {
		type: TOGGLE_FULFILLMENT,
		product,
		// payload:axios({
		// 	url:`${URL_ENDPOINT}/api/admin/orders/fulfill/${order._id}/${product._id}`,
		// 	method:'get',
		// 	withCredentials: true
		// })
	}
}

export const updateAdminControls = ( adminControls ) => {
	return {
		type: UPDATE_ADMIN_CONTROLS,
		adminControls
	}
}

export const updateEmailCampaigns = ( emailCampaigns ) => {
	return {
		type: UPDATE_EMAIL_CAMPAIGNS,
		emailCampaigns
	}
}

export const updateOrderPaymentObject = ( payment ) => {
	return {
		type: UPDATE_ORDER_PAYMENT_OBJECT,
		payment
	}
}

export const updatePickupDate = (product, pickupDate) => {
	return {
		type: UPDATE_PICKUP_DATE,
		product,
		pickupDate
	}
}


export const updateLeadTime = (product, leadTime) => {
	
	return {
		type: UPDATE_LEAD_TIME,
		product,
		leadTime
	}

}

export const updateTrackingCode = (product, code) => {

	return {
		type: UPDATE_TRACKING_CODE,
		product,
		trackingCode: code,
		// payload: axios({
		// 	url: `${URL_ENDPOINT}/api/admin/orders/trackCode/${order._id}/${product._id}`,
		// 	method:'put',
		// 	data: { code }
		// })
	}

}

export const updateOrder = (order) => {
	
	return {
		type: UPDATE_ORDER,
		order
	}

}



// WEBPACK FOOTER //
// ./src/components/orders-v2/actions/index.js